import FiltersV2 from './FiltersV2'
import ConversationListV2 from './ConversationListV2'
import LoadingList from './LoadingList'
import MobileInboxSelect from '@SonarCX/pages/ClientChats/Mobile/MobileInboxSelect'

import { useAppSelector } from '../../../hooks/redux'
import { selectConvo } from '../../../slices/convo'
import useStyles from './styles'

const ConversationsV2 = () => {
  const { dataFetched } = useAppSelector(selectConvo)

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <MobileInboxSelect noShadow />
      <FiltersV2 />

      {dataFetched ? (
        <ConversationListV2 mobile={false} />
      ) : (
        <LoadingList mobile={false} />
      )}
    </div>
  )
}
export default ConversationsV2
